module.exports = __webpack_public_path__ + "static/media/MT2.35c520df.mp3";